import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import { Typography } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useIntl } from "react-intl";
import { messages } from "./ChromeDesktopGuide.messages";
import ChromeDesktop1 from "../../../../../Assets/chrome-desktop-1.png";
import ChromeDesktop2 from "../../../../../Assets/chrome-desktop-2.png";
import { useStyles } from "./ChromeDesktopGuide.style";

const ChromeDesktopGuide = () => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <>
      <DialogTitle id="form-dialog-title">
        {intl.formatMessage(messages.dialogTitle)}
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">
          <ol>
            <li>{intl.formatMessage(messages.step1)}</li>
            <li>{intl.formatMessage(messages.step2)}</li>
            <li>{intl.formatMessage(messages.step3)}</li>
            <li>{intl.formatMessage(messages.step4)}</li>
            <img
              className={classes.image}
              src={ChromeDesktop1}
              alt={intl.formatMessage(messages.imgAltText)}
            />
            <li>{intl.formatMessage(messages.step5)}</li>
            <img
              style={{ maxWidth: 500 }}
              className={classes.image}
              src={ChromeDesktop2}
              alt={intl.formatMessage(messages.imgAltText)}
            />
          </ol>
        </Typography>
      </DialogContent>
    </>
  );
};

export default ChromeDesktopGuide;
